<div class="reviews-section">
  <div class="section-header">
    <div class="section-icon">💬</div>
    <h2>{{ 'HOME.CLIENTINFO' | translate }} <span class="highlight-text">{{'HOME.CLIENTINFO_SAY' | translate }}</span></h2>
    <p class="section-subtitle">{{ 'HOME.REVIEWS.SECTION_SUBTITLE' | translate }}</p>
  </div>

  <div class="reviews-container">
    @for (review of reviews; track review; let i = $index) {
      <div class="review-card">
        <div class="review-content">
          <div class="review-stars">
            @for (star of [1,2,3,4,5]; track star) {
              <span class="star">⭐</span>
            }
          </div>
          <p class="review-text">{{ review.text | translate }}</p>
          <div class="review-author">
            <div class="author-avatar">
              <img loading="lazy" [src]="review.avatar" [alt]="review.name">
            </div>
            <div class="author-info">
              <h4 class="author-name">{{ review.name }}</h4>
              <p class="author-job">{{ review.job | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>